// extracted by mini-css-extract-plugin
export var baseButton = "_vx-0";
export var controlsArrowKeys = "_vx-1";
export var controlsResetButton = "_vx-2";
export var lightGameButton = "_vx-4 _vx-0";
export var playAgainButton = "_vx-5 _vx-0";
export var startGameButton = "_vx-3 _vx-0";